(function () {
  function initAutoScroll() {
    var scroller = document.querySelector('.resource-list__carousel slideshow-slides');
    if (!scroller) return;

    var speed = 1.3;
    var paused = false;
    var resumeTimer = null;

    // Force smooth scrolling settings
    scroller.style.overflow = 'auto';
    scroller.style.scrollSnapType = 'none';
    scroller.style.scrollBehavior = 'auto';

    // Clone all slides for infinite loop
    var slides = scroller.querySelectorAll('slideshow-slide');
    slides.forEach(function(slide) {
      var clone = slide.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      scroller.appendChild(clone);
    });

    var totalWidth = scroller.scrollWidth;
    var halfWidth = totalWidth / 2;

    function scroll() {
      if (!paused) {
        scroller.scrollLeft += speed;
        // Infinite loop - when halfway, jump back to start silently
        if (scroller.scrollLeft >= halfWidth) {
          scroller.scrollLeft = scroller.scrollLeft - halfWidth;
        }
      }
      requestAnimationFrame(scroll);
    }

    // Desktop hover pause
    scroller.addEventListener('mouseenter', function () { paused = true; });
    scroller.addEventListener('mouseleave', function () { paused = false; });

    // Mobile touch pause + resume
    scroller.addEventListener('touchstart', function () {
      paused = true;
      clearTimeout(resumeTimer);
    }, { passive: true });

    scroller.addEventListener('touchend', function () {
      resumeTimer = setTimeout(function () { paused = false; }, 2000);
    });

    requestAnimationFrame(scroll);
  }

  window.addEventListener('load', function () {
    setTimeout(initAutoScroll, 1000);
  });
})();
